export function getFileName({ fileName }: { fileName?: string }): string {
  if (!fileName) {
    return ''
  }
  const firstIndexTrace = fileName.indexOf('-')

  return fileName.slice(firstIndexTrace + 1, fileName.length)
}
